import { render, staticRenderFns } from "./SupplierRating.vue?vue&type=template&id=08114162&scoped=true"
import script from "./SupplierRating.vue?vue&type=script&lang=js"
export * from "./SupplierRating.vue?vue&type=script&lang=js"
import style0 from "./SupplierRating.vue?vue&type=style&index=0&id=08114162&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08114162",
  null
  
)

export default component.exports